// extracted by mini-css-extract-plugin
module.exports = {"list":"ContactList_list__sPvk1"};